/* UGREEN Festive Edition — enhancements (deferred).
   Rotating top-bar messages, ambient hero particles, preview badge.
   Rendering itself happens inline in snippets/ug-festive.liquid. */
(function () {
  var U = window.UGF;
  if (!U || !document.documentElement.classList.contains('ugf-on')) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Top bar: rotate messages every 4.5 s ---------- */
  (function rotate() {
    var box = document.querySelector('.ugf-bar__msgs');
    if (!box) return;
    var items = box.querySelectorAll('.ugf-bar__msg');
    if (items.length < 2 || reduce) return;
    var i = 0, paused = false;
    box.closest('.ugf-bar').addEventListener('mouseenter', function () { paused = true; });
    box.closest('.ugf-bar').addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      var cur = items[i];
      i = (i + 1) % items.length;
      var nxt = items[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      nxt.classList.remove('is-out'); nxt.classList.add('is-on');
      setTimeout(function () { cur.classList.remove('is-out'); }, 700);
    }, 4500);
  })();

  /* ---------- Hero image: make sure it fades in even if load fired early ---------- */
  var heroImg = document.querySelector('.ugf-hero__media img');
  if (heroImg && heroImg.complete && heroImg.naturalWidth) heroImg.classList.add('is-in');

  /* ---------- Ambient particles (embers / petals / sparkle / snow / confetti) ---------- */
  (function particles() {
    var type = U.stage && U.stage.particles;
    var cv = document.querySelector('.ugf-hero__fx');
    if (!type || type === 'none' || !cv || reduce) return;
    var ctx = cv.getContext('2d');
    if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, P = [], running = false, raf = 0, last = 0;
    var mobile = window.innerWidth < 750;
    var N = { embers: mobile ? 16 : 34, petals: mobile ? 10 : 20, sparkle: mobile ? 14 : 28, snow: mobile ? 26 : 60, confetti: mobile ? 18 : 40 }[type] || 20;
    var gold = getComputedStyle(document.documentElement).getPropertyValue('--ugf-gold').trim() || '#d8a640';
    var palettes = {
      embers: ['255,196,92', '255,170,60', '255,225,150'],
      petals: (U.stage.theme === 'rose') ? ['232,150,160', '245,190,195', '214,120,135'] : ['246,164,40', '236,120,24', '255,196,60'],
      sparkle: ['255,236,180', '255,255,255', '235,205,140'],
      snow: ['255,255,255', '235,242,255'],
      confetti: ['232,211,162', '212,175,55', '255,244,214', '190,160,90']
    };
    var cols = palettes[type] || palettes.embers;
    function rnd(a, b) { return a + Math.random() * (b - a); }
    function size() {
      var r = cv.getBoundingClientRect();
      W = r.width; H = r.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(p, initial) {
      p.c = cols[(Math.random() * cols.length) | 0];
      p.x = rnd(0, W);
      // keep particles mostly to the right half on desktop so the headline stays clean
      if (!mobile && Math.random() < .7) p.x = rnd(W * 0.45, W);
      if (type === 'embers') { p.y = initial ? rnd(0, H) : H + 10; p.r = rnd(1, 2.6); p.vy = -rnd(8, 22); p.vx = rnd(-6, 6); p.a = rnd(.35, .9); p.ph = rnd(0, 6.28); }
      else if (type === 'petals') { p.y = initial ? rnd(-H, H) : -20; p.r = rnd(4, 8); p.vy = rnd(14, 30); p.vx = rnd(-10, 10); p.rot = rnd(0, 6.28); p.vr = rnd(-1.2, 1.2); p.a = rnd(.55, .9); p.ph = rnd(0, 6.28); }
      else if (type === 'sparkle') { p.y = rnd(0, H); p.r = rnd(2, 5.5); p.a = 0; p.life = 0; p.dur = rnd(2.2, 4.5); p.delay = initial ? rnd(0, 4) : rnd(0, 1.5); }
      else if (type === 'snow') { p.y = initial ? rnd(0, H) : -6; p.r = rnd(.8, 2.6); p.vy = rnd(10, 28); p.vx = rnd(-6, 6); p.a = rnd(.35, .85); p.ph = rnd(0, 6.28); }
      else { p.y = initial ? rnd(-H, H) : -14; p.w = rnd(3, 6); p.h = rnd(7, 13); p.vy = rnd(22, 46); p.vx = rnd(-12, 12); p.rot = rnd(0, 6.28); p.vr = rnd(-3, 3); p.a = rnd(.6, .95); p.ph = rnd(0, 6.28); }
      return p;
    }
    function init() { size(); P = []; for (var i = 0; i < N; i++) P.push(spawn({}, true)); }
    function star(x, y, r) {
      ctx.beginPath();
      ctx.moveTo(x, y - r); ctx.quadraticCurveTo(x, y, x + r, y); ctx.quadraticCurveTo(x, y, x, y + r);
      ctx.quadraticCurveTo(x, y, x - r, y); ctx.quadraticCurveTo(x, y, x, y - r); ctx.fill();
    }
    function frame(t) {
      if (!running) return;
      var dt = Math.min(.05, (t - (last || t)) / 1000); last = t;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < P.length; i++) {
        var p = P[i];
        if (type === 'sparkle') {
          if (p.delay > 0) { p.delay -= dt; continue; }
          p.life += dt; var k = p.life / p.dur;
          if (k >= 1) { spawn(p, false); continue; }
          var al = Math.sin(k * Math.PI);
          ctx.fillStyle = 'rgba(' + p.c + ',' + (al * .9).toFixed(3) + ')';
          ctx.shadowColor = 'rgba(' + p.c + ',.8)'; ctx.shadowBlur = 8;
          star(p.x, p.y, p.r * (0.6 + al * 0.6));
          continue;
        }
        p.ph += dt;
        p.x += (p.vx + Math.sin(p.ph * 1.3) * 6) * dt;
        p.y += p.vy * dt;
        if (type === 'embers') {
          var flick = .65 + Math.sin(p.ph * 6) * .35;
          ctx.shadowColor = 'rgba(' + p.c + ',.9)'; ctx.shadowBlur = 10;
          ctx.fillStyle = 'rgba(' + p.c + ',' + (p.a * flick).toFixed(3) + ')';
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
          if (p.y < -12) spawn(p, false);
        } else if (type === 'snow') {
          ctx.shadowBlur = 0;
          ctx.fillStyle = 'rgba(' + p.c + ',' + p.a.toFixed(3) + ')';
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
          if (p.y > H + 8) spawn(p, false);
        } else if (type === 'petals') {
          p.rot += p.vr * dt;
          ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.shadowBlur = 0;
          ctx.fillStyle = 'rgba(' + p.c + ',' + p.a.toFixed(3) + ')';
          ctx.beginPath(); ctx.ellipse(0, 0, p.r, p.r * .55, 0, 0, 6.283); ctx.fill(); ctx.restore();
          if (p.y > H + 20) spawn(p, false);
        } else {
          p.rot += p.vr * dt;
          ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.shadowBlur = 0;
          ctx.fillStyle = 'rgba(' + p.c + ',' + p.a.toFixed(3) + ')';
          ctx.fillRect(-p.w / 2, -p.h / 2 * Math.abs(Math.cos(p.ph * 3)), p.w, p.h * Math.abs(Math.cos(p.ph * 3)));
          ctx.restore();
          if (p.y > H + 20) spawn(p, false);
        }
      }
      raf = requestAnimationFrame(frame);
    }
    function start() { if (running) return; running = true; last = 0; raf = requestAnimationFrame(frame); }
    function stop() { running = false; cancelAnimationFrame(raf); }
    init();
    var vis = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { vis = e[0].isIntersecting; (vis && !document.hidden) ? start() : stop(); }, { threshold: 0.05 }).observe(cv);
    } else start();
    document.addEventListener('visibilitychange', function () { (vis && !document.hidden) ? start() : stop(); });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(init, 200); });
  })();

  /* ---------- Preview badge (only in preview mode) ---------- */
  if (U.preview || U.simulated) {
    var b = document.createElement('div');
    b.className = 'ugf-preview';
    var nm = (U.stage && (U.stage.name || U.stage.id)) || '';
    b.innerHTML = 'Festive preview: <strong></strong> <a href="?ugf=auto&amp;ugf_date=now">Back to live</a>';
    b.querySelector('strong').textContent = nm + (U.simulated ? ' · ' + new Date(U.now).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }) : '');
    document.body.appendChild(b);
  }
})();
